import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { styled, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Card from "../../../components/Cards/Card";
import { useQlik } from "../../../context/Qlik";
import NativeObject from "../../../components/NativeObject/NativeObject";
import { useSelections } from "../../../context/Selections";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});

const LayoutCardWrapper = styled("div")({
  borderRadius: "16px",
  display: "flex",
  width: "100%",
  paddingRight: "10px",
});

function GeneralDesktop({ app, config, filter }) {
  const { cards } = config.performanceDetail;
  const [selectedYear, setSelectedYear] = useState("FY23");
  const { selections } = useSelections();
  const { setSwitchOnDemand } = useQlik();

  const [alignment, setAlignment] = useState("Sell Out");

  const tooltips = {
    Regionais: {
      "Sell Out": "Ranking de Performance percentual de sell out por regional",
      "Cobertura Total":
        "Ranking de Cobertura Total em percentual por regional",
      "Cobertura Qualificada":
        "Ranking de Cobertura Qualificada em percentual por regional",
    },
    "Grupos Distribuidores": {
      "Sell Out":
        "Ranking de Performance percentual de sell out por distribuidor",
      "Cobertura Total":
        "Ranking de Cobertura Total em percentual por distribuidor",
      "Cobertura Qualificada":
        "Ranking de Cobertura Qualificada em percentual por distribuidor",
    },
    Detalhamento: {
      "Sell Out":
        "O detalhamento de performance de sell out mostra a Meta vs Realizado por regional e clicando na seta de + você pode ter a visão por distribuidor",
      "Cobertura Total":
        "O detalhamento de Cobertura Total mostra a Meta vs Realizado por regional e clicando na seta de + você pode ter a visão por distribuidor",
      "Cobertura Qualificada": `O detalhamento de Cobertura Qualificada mostra a Meta vs Realizado por regional e clicando na seta de + você pode ter a visão por distribuidor. Importante: Na cobertura qualificada o distribuidor pontua positivando ao menos ${
        selectedYear === "FY23" ? "5" : "6"
      } dos 6 sku's do Sortimento Mínimo do canal`,
    },
  };

  useEffect(() => {
    handleChange(filter);
  }, [filter]);

  useEffect(() => {
    if (selections.length) {
      const selection =
        selections.find((selection) => selection.qField === "Ano")
          ?.qSelected === "FY23" ?? false;
      if (selection && selectedYear === "FY24") {
        setSelectedYear("FY23");
      }
      if (!selection && selectedYear === "FY23") {
        setSelectedYear("FY24");
      }
    }
  }, [selections]);

  const handleChange = async (newAlignment) => {
    await app.field("%Selecao").selectMatch(newAlignment);
    setAlignment(newAlignment);
  };

  return (
    <div className="app investments">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div
              style={{
                display: "flex",
                width: "100%",
                padding: "0 8px",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h1
                style={{
                  marginLeft: "10px",
                }}
              >
                {alignment}
              </h1>
            </div>
          </LayoutCardWrapper>
          <LayoutCardWrapper style={{ height: "50%" }}>
            <Card
              header={{
                hardTitle: "Regionais",
                tooltip: tooltips["Regionais"][alignment],
              }}
              style={{
                width: "100%",
              }}
            >
              <NativeObject
                app={app}
                key="qNSBJp"
                reference={{ id: "qNSBJp" }}
              />
            </Card>
            <Card
              header={{
                hardTitle: "Grupos Distribuidores",
                tooltip: tooltips["Grupos Distribuidores"][alignment],
              }}
              style={{
                width: "100%",
              }}
            >
              <NativeObject
                app={app}
                key="YDypPM"
                reference={{ id: "YDypPM" }}
              />
            </Card>
          </LayoutCardWrapper>
          {/* KPIS */}
          <LayoutCardWrapper style={{ height: "60%" }}>
            <Card
              exportTable
              app={app}
              exportContainer
              exportTableId="VZezD"
              header={{
                hardTitle: "Detalhamento",
                tooltip: tooltips["Detalhamento"][alignment],
              }}
              style={{ width: "100%", alignItems: "center" }}
            >
              <NativeObject
                app={app}
                key="VZezD"
                reference={{ id: "VZezD" }}
                style={{ marginTop: "20px" }}
              />
            </Card>
          </LayoutCardWrapper>
          {/* KAPI E GRAFICO CENTRAL */}
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

GeneralDesktop.defaultProps = {
  app: null,
  config: {},
};

GeneralDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default GeneralDesktop;
